import z from 'zod';

export const numeric = ({ min = 1, max = 10 }) =>
  z.union([
    z.number(),
    z
      .string()
      .min(min)
      .max(max)
      .regex(/^\d{1,60}$/)
      .transform(Number),
  ]);

export const year = ({ min = 2000, max = 2100 }) =>
  z
    .string()
    .min(4)
    .max(4)
    .regex(/^\d{4}$/)
    .transform(Number)
    .refine((value) => value >= min && value <= max);

export const slug = ({
  min = 1,
  max = 128,
}: { min?: number; max?: 16 | 32 | 64 | 128 | 256 } = {}) =>
  z
    .string()
    .min(min)
    .max(max)
    .regex(/^[a-z0-9-_]{1,256}$/);
